import { render, staticRenderFns } from "./PTplInfoModal.vue?vue&type=template&id=d389c36c&"
import script from "./PTplInfoModal.vue?vue&type=script&lang=js&"
export * from "./PTplInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports